import { Nav } from '@/components/nav';
import { ScrollProvider } from '@/scroll/scroll-provider';
import { useFontsReady } from '@/scroll/use-fonts-ready';
import { Api } from '@/sections/api';
import { Coins } from '@/sections/coins';
import { Contact } from '@/sections/contact';
import { Coverage } from '@/sections/coverage';
import { Footer } from '@/sections/footer';
import { Gateway } from '@/sections/gateway';
import { Hero } from '@/sections/hero';

/**
 * Normal-flow sections whose copy reveals once as each enters the viewport. The only gate
 * before scrolling unlocks is web fonts, so ScrollTrigger measures final line heights.
 */
export function App() {
  const fontsReady = useFontsReady();

  return (
    <ScrollProvider enabled={fontsReady}>
      <Nav />
      <main id="top" className="relative">
        <Hero />
        <Coins />
        <Gateway />
        <Coverage />
        <Api />
        <Contact />
      </main>
      <Footer />
    </ScrollProvider>
  );
}
